<template>
  <div class="h-screen w-screen bg-white justify-center mt-12 flex-wrap">
    <p class="text-blue-600 text-9xl">404</p>
    <p class="text-blue-600 text-l">Oops, there doesn't seem to be anything here.</p>
  </div>
</template>

<script>
  export default {

  }
</script>
